<template>
  <div>
    <header-component />

    <div class="px-2 py-2 w-full">
      <div class="card">
        <div class="card-header">
          <h3 class="mb-0" style="text-transform:capitalize;">Payment Modes List</h3>
          <div class="col-lg-12 col-5 text-right">
            <base-button size="sm" type="primary" @click="createPaymentMode">Add New</base-button>
          </div>
        </div>
        <el-table
          class="table-responsive table-flush"
          header-row-class-name="thead-light"
          :data="paymentModeList"
        >
          <el-table-column label="Payment Mode" min-width="170px" prop="label" sortable></el-table-column>
          <el-table-column min-width="70px">
            <template slot-scope="scope">
              <el-dropdown slot="dropdown" @command="command => handleAction(scope.row, command)">
                <el-button type="primary" size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                  <el-dropdown-item command="edit">Edit</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-dialog
        title="Add Payment Mode"
        :visible.sync="addPaymentMode"
        @close="addPaymentMode = false"
      >
        <add-payment-mode @close="addPaymentMode=false"></add-payment-mode>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button
} from "element-ui";
import { mapGetters, mapActions, mapMutations } from "vuex";
import AddPaymentMode from "./AddPaymentMode";
import headerComponent from "../Components/HeaderComponent";

export default {
  data: () => {
    return {
      addPaymentMode: false
    };
  },

  computed: {
    ...mapGetters({
      paymentModeList: "paymentMode/getPaymentModes",
      paymentMode: "paymentMode/getPaymentMode"
    })
  },

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    "add-payment-mode": AddPaymentMode,
    [Dialog.name]: Dialog,
    [Button.name] : Button,
    "header-component": headerComponent

  },

  mounted() {
    this.getPaymentModes();
  },

  methods: {
    ...mapActions({
      getPaymentModes: "paymentMode/getPaymentModes",
      fetchPaymentMode: "paymentMode/fetchPaymentMode"
    }),
    ...mapMutations({
      setPaymentMode: "paymentMode/setPaymentMode",
      resetPaymentMode: "paymentMode/resetPaymentMode"
    }),
    handleAction(paymentMode, command) {
      if (command === "edit") {
        this.fetchPaymentMode(paymentMode.paymentModeId).then(res => {
          this.addPaymentMode = true;
          this.setPaymentMode(res);
        });
      }
    },
    createPaymentMode() {
      this.resetPaymentMode();
      this.addPaymentMode = true;
    }
  }
};
</script>